export default __webpack_public_path__ + "static/media/slots_img_desktop.a191b6b5.png";